import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle
    , Grid, TextField, Typography, Hidden } from '@mui/material';
import { DataGrid, GridToolbarContainer, GridOverlay } from "@mui/x-data-grid";
import { Search as IconSearch } from "@mui/icons-material";
import React, { useState } from 'react';
import { PaperComponentDraggable } from "./PaperComponentDraggable";
import * as participanteService from "../services/participanteService";

// Busqueda de participantes, para elegir a quien se evalua.
const ParticipanteSearch = (props) => {
    const [filters, setFilters] = useState({
        member: "",
    });
    const [results, setResults] = useState([]);
    // Fila resaltada con un clic. Se elige con doble clic o con Aceptar.
    const [filaElegida, setFilaElegida] = useState(null);
    const [cargando, setCargando] = useState(false);

    const fetchResults = async () => {
        setCargando(true);

        const data = await participanteService.getsParticipantesResumenView()
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        // El listado de participantes es chico: se filtra en el navegador.
        let lista = data || [];

        if (filters.member != null && filters.member.trim() !== "") {
            lista = lista.filter((row) => (row.participante || "").toLowerCase()
                .includes(filters.member.toLowerCase()));
        }

        setResults(lista);
        setFilaElegida(null);
        setCargando(false);
    }

    React.useEffect(() => {
        fetchResults();
    }, [])

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
            </GridToolbarContainer>
        );
    }

    const columns = [
        { field: 'participante', headerName: 'Participante', width: 250, sortable: true },
        { field: 'id', headerName: 'ID', width: 80, sortable: false },
    ];

    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"sm"}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Typography>Buscar Participante</Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "350px", maxHeight: "400px" }}>
                <Grid container item xs={12} sm={12} spacing={1} padding={1}>
                    <Grid item xs={8} sm={9}>
                        <TextField
                            name="member"
                            label="Participante"
                            value={filters.member}
                            fullWidth
                            onChange={(event) => {
                                setFilters({ ...filters, member: event.target.value })
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Button variant="outlined" onClick={() => { fetchResults() }} fullWidth>
                            {<Hidden smDown>Buscar</Hidden>}
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <DataGrid
                            rows={results}
                            columns={columns}
                            initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
                            pageSize={5}
                            pageSizeOptions={[5, 10]}
                            disableColumnMenu
                            components={{ Toolbar: CustomToolbar, LoadingOverlay: () => (
                                <GridOverlay><CircularProgress /></GridOverlay>
                            ) }}
                            loading={cargando}
                            rowHeight={25}
                            disableRowSelectionOnClick={false}
                            onRowClick={(params) => setFilaElegida(params.row)}
                            onRowDoubleClick={(params) => {
                                props.setSelection(params.row);
                                props.openClose();
                            }}
                            autoHeight={true}
                            sx={{ "& .MuiDataGrid-columnHeader ": { backgroundColor: "#1976d2", color: "white" } }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="primary" disabled={!filaElegida} onClick={() => {
                    if (filaElegida) {
                        props.setSelection(filaElegida);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ParticipanteSearch;
